import { useState } from 'react'
import type { WorkflowTriggerInput } from 'app/generated/graphql'
import type { MatchWindowDays } from 'app/lib/workflows/lookback/types'
import { engineEventNoun } from 'app/lib/workflows/triggerCatalog'
import type { AddToPipelineFlowNode, WorkflowNode } from 'app/types/workflows'
import { MatchesPanel } from './MatchesPanel'
import { useTriggerLookback } from './useTriggerLookback'

/** The Matches panel wired to its data; mounted only while open. */
export function WorkflowMatches({
  onClose,
  trigger,
  locationId,
  workflowId,
  nodes,
  timeZone,
}: {
  onClose: () => void
  /** The trigger as compiled for the engine from the canvas right now, saved or not: testing a
   *  change to the entry conditions must never require activating the workflow first. */
  trigger?: WorkflowTriggerInput
  locationId?: string
  workflowId?: string
  nodes: WorkflowNode[]
  timeZone?: string | null
}) {
  const [windowDays, setWindowDays] = useState<MatchWindowDays>(30)
  const lookback = useTriggerLookback({
    open: true,
    trigger,
    locationId,
    range: { aheadDays: windowDays },
    workflowId,
    targetPipelineId: nodes.find((node): node is AddToPipelineFlowNode => node.type === `addToPipeline`)?.data
      .pipelineId,
  })

  return (
    <MatchesPanel
      open
      mode="upcoming"
      onClose={onClose}
      lookback={lookback}
      windowDays={windowDays}
      onWindowChange={setWindowDays}
      sourceNoun={trigger ? engineEventNoun(String(trigger.event)) : `trigger`}
      timeZone={timeZone}
      needsLocation={!locationId}
    />
  )
}
